/*
 * logs/constants.js
 *
 * Ensure each action has a corresponding type here.
 * To avoid reducer conflicts, these should be prefixed
 * with the parent directory.
 */

export const FETCH_AUDIT_LOGS = "logs/FETCH_AUDIT_LOGS";
export const FETCH_AUDIT_LOGS_START = "logs/FETCH_AUDIT_LOGS_START";
export const FETCH_AUDIT_LOGS_SUCCESS = "logs/FETCH_AUDIT_LOGS_SUCCESS";
export const FETCH_AUDIT_LOGS_FAILED = "logs/FETCH_AUDIT_LOGS_FAILED";

export const FETCH_AUDIT_LOG_ENTITIES = "logs/FETCH_AUDIT_LOG_ENTITIES";
export const FETCH_AUDIT_LOG_ENTITIES_START =
  "logs/FETCH_AUDIT_LOG_ENTITIES_START";
export const FETCH_AUDIT_LOG_ENTITIES_SUCCESS =
  "logs/FETCH_AUDIT_LOG_ENTITIES_SUCCESS";
export const FETCH_AUDIT_LOG_ENTITIES_FAILED =
  "logs/FETCH_AUDIT_LOG_ENTITIES_FAILED";

// Logs VirtualizedTable parameters in px
export const LOGS_TABLE_ROW_HEIGHT = 56;
export const MIN_WIDTH_AUTHOR = 150;
export const MIN_WIDTH_DATE = 150;
export const MIN_WIDTH_DESCRIPTION = 600;
export const MIN_WIDTH_EVENT = 150;
export const MIN_WIDTH_TARGET = 200;
